<div class="relative w-full h-full">
  @if (hasError()) {
    <div class="flex items-center justify-center w-full h-full">
      <div>
        <p class="text-sm">Unable to load HTML content</p>
      </div>
    </div>
  }

  <div
    #htmlContainer
    class="w-full h-full"
    [class.hidden]="hasError() || isLoading()"
    role="document"
    aria-label="HTML content viewer"
  ></div>
</div>
